<template>
    <div class="down-list">
        <!-- 9指南共识 -->
      <div class="download-list-section">
        <div class="download-list-section-box">
          <div class="download-list-section-box-left">
            <img v-if="dataItem.type_text == '图文'" src="/static/two/download_article.svg" alt="" />
            <img v-else-if="dataItem.type_text == 'PDF'" src="/static/two/download_pdf.svg" alt="" />
            <img v-else src="/static/third/icon_course_download_pic.svg" alt="" />
          </div>
          <div class="download-list-section-box-center">
            <div class="download-list-section-box-center-title">
              <span class="download-list-section-title" @click="downloadItem(dataItem)">{{ dataItem.content.title }}</span>
            </div>
            <div class="download-list-section-box-center-desc">
                                        <span class="download-list-section-box-center-desc-label">
                                            {{ dataItem.created_at }}
                                            <span style="margin-left: 8px" v-if="dataItem.type_text == '图文'">{{ dataItem.view_count }}人阅读</span>
                                            <span style="margin-left: 8px" v-else>{{ dataItem.content.download_count }}人下载</span>
                                            <span style="margin-left: 11px" @click.stop="favorite(dataItem)">
                                                <img v-if="dataItem.content.isFavorite" src="/static/two/download_favorite.svg" alt="" />
                                                <img v-else src="/static/two/download_unfavorite.svg" alt="" />
                                                <span v-if="dataItem.content.isFavorite">已收藏</span>
                                                <span v-else>收藏</span>
                                            </span>
                                        </span>
            </div>
          </div>
          <div class="download-list-section-box-right">
            <img
                @click.stop="downloadItem(dataItem)"
                v-if="dataItem.isDownload && dataItem.type_text != '图文'"
                src="/static/two/downloaded.svg"
                alt=""
            />
            <img
                @click.stop="downloadItem(dataItem)"
                v-else-if="!dataItem.isDownload && dataItem.type_text != '图文'"
                style="margin-right: 10px"
                src="/static/two/download.svg"
                alt=""
            />
            <div @click.stop="downloadItem(dataItem)" v-else></div>
          </div>
        </div>
      </div>
      <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
        <div class="share-img">
          <img :src="current_item.link" style="width: 100%" alt="">
        </div>
        <div style="font-family: PingFangSC-Regular;font-size: 14px;color: #FFFFFF;text-align: center;">可长按图片保存到相册</div>
        <div class="share-cancel-btn" @click="showShareDialog = false">
          <img src="/static/img/course/icon_course_share_close.svg" alt="">
        </div>
      </van-dialog>
    </div>
</template>

<script>
import Interface from '@/util/interface'
export default {
    props: {
        dataItem: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
          showShareDialog : false,
          current_item : {},
        }
    },
    methods: {
      goDetail(dataItem) {
        this.$router.push({ name: 'guide-detail', params: { id: dataItem.content.id } })
        Interface.getData('get', `/course-phase/api/recommend_v2/${dataItem.id}/view`)
        Interface.getData('get', `/course/api/content_relation/${dataItem.id}/view`)
      },
      async downloadItem(item) {
        if (item.type_text == 'PDF') {
          var u = navigator.userAgent
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
          if (isiOS) {
            if (item.filesize < 20480) {
              await this.getDetailDownload(item.id)
              item.download_count += 1
              window.location.href = item.link
              return
            }
          }
          this.showEmailVisible = true
          this.current_item = item
        } else if (item.type_text == '图文') {
          this.$router.push({ name: 'download-detail', params: { id: item.id } })
        } else {
          this.showShareDialog = true
          this.current_item = item
        }
      },
      favorite(item){
        console.log('item====', item)
        Interface.getData('get', Interface.download.favorite+item.origin_id
        ).then((res) => {
          if(res.code == 0){
            item.isFavorite = !item.isFavorite
          }
        })
      },
      sendEmail(){
        let params = {
          id : this.current_item.id,
          email : this.emailInputValue
        }
        localStorage.setItem("email",params.email)
        Interface.getData('post', Interface.download.email,params).then((res) => {
          if(res.code == 0){
            this.$dialog.alert({
              title: '提示',
              message: '已经记录您的邮箱 , 稍后将发送文件到您的邮箱中',
              confirmButtonText: "确认"
            })
          }
        })
      }
    }
}
</script>

<style lang="scss" scoped>
@import "@/components/tags.scss";
@import "@/components/download-list-new.scss";
@import "@/components/share.scss";
.download-list-section{
  width: 355px;
  height: 92px;
  margin: 0 auto;
  background: #FFFFFF;
  border-radius: 8px;
  padding: 0;
}
.download-list-section-box-left{
  margin-bottom: 20px;
}
.download-list-section-box-right{
  img{
    margin-left: 0px;
  }
}
.download-list-section-box-right{
  margin-top: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/newItemconent/modules/guide.vue